export const API_BASE_URL = "https://api.biomeee.com";
// export const API_BASE_URL = `http://localhost:8080`;
export const APP_BASE_URL = `https://biomeee.com`;
// export const APP_BASE_URL = `http://localhost:3000`;
export const planList = [
  {
    id: "free",
    name: "My 1st BioME!",
    priceLabel: "Free Plan",
    price: 0,
    billingCycle: null,
    badge: null,
    features: [
      "Basic Landing Page",
      "4 Albums",
      "Capped Showcasing Space",
      "Audio CTA",
      "Limited Immersion UIs",
    ],
  },
  {
    id: "monthly",
    name: "BioMExplorer",
    priceLabel: "$6.50",
    price: 6.5,
    billingCycle: "month",
    badge: "🔥 Beta Price slashed 30%!",
    features: [
      "Everything in Free",
      "Unlimited Albums",
      "5GB Expandable Showcases",
      "More Immersive Features",
      "Customer support",
    ],
  },
  {
    id: "yearly",
    name: "BioMExplorer Yearly",
    priceLabel: "$65",
    price: 65,
    billingCycle: "year",
    badge: "Most Popular 🚀",
    features: [
      "Everything in Monthly",
      "Full Range of UI Perks/Features",
      "Boost Conversions with 10min",
      "Creator Profile Pop up Campaigns",
      "Priority Customer Support",
      "Watch full features on YT here",
    ],
  },
];

export const staticThemeList = [
  {
    url: "https://f005.backblazeb2.com/file/biome12/1761668030260-cropped-image.jpg",
    isPremium: false,
  },
  {
    url: "https://f005.backblazeb2.com/file/biome12/1761668047168-cropped-image.jpg",
    isPremium: false,
  },
  {
    url: "https://f005.backblazeb2.com/file/biome12/1761668056035-cropped-image.jpg",
    isPremium: false,
  },
  {
    url: "https://f005.backblazeb2.com/file/biome12/1761668065065-cropped-image.jpg",
    isPremium: false,
  },
  {
    url: "https://cdn.biomeee.com/file/biome12/1770480491642-cropped-image.jpg",
    isPremium: false,
  },
  {
    url: "https://cdn.biomeee.com/file/biome12/1770480506134-cropped-image.jpg",
    isPremium: false,
  },
  {
    url: "https://cdn.biomeee.com/file/biome12/1770480519640-cropped-image.jpg",
    isPremium: false,
  },
  {
    url: "https://cdn.biomeee.com/file/biome12/1770480535439-cropped-image.jpg",
    isPremium: false,
  },
  {
    url: "https://f005.backblazeb2.com/file/biome12/theme10.jpg",
    isPremium: true,
  },
  {
    url: "https://f005.backblazeb2.com/file/biome12/theme2.jpg",
    isPremium: true,
  },
  {
    url: "https://f005.backblazeb2.com/file/biome12/theme3.jpg",
    isPremium: true,
  },
  {
    url: "https://f005.backblazeb2.com/file/biome12/theme4.jpg",
    isPremium: true,
  },
  {
    url: "https://f005.backblazeb2.com/file/biome12/theme5.jpg",
    isPremium: true,
  },
  {
    url: "https://f005.backblazeb2.com/file/biome12/theme1.jpg",
    isPremium: true,
  },
  {
    url: "https://f005.backblazeb2.com/file/biome12/theme6.jpg",
    isPremium: true,
  },
  {
    url: "https://f005.backblazeb2.com/file/biome12/theme7.jpg",
    isPremium: true,
  },
  {
    url: "https://f005.backblazeb2.com/file/biome12/theme8.jpg",
    isPremium: true,
  },
  {
    url: "https://f005.backblazeb2.com/file/biome12/theme9.jpg",
    isPremium: true,
  },
];

export const settings1x = {
  dots: false,
  className: "center",
  centerMode: true,
  infinite: true,
  speed: 500,
  slidesToShow: 2, // adjust for 1-row horizontal slider
  slidesToScroll: 1,
};

export const settings2x = {
  dots: false,
  className: "center",
  centerMode: true,
  infinite: true,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  rows: 2, // 🔥 2 rows slider
  slidesPerRow: 1,
};

export const FONT_OPTIONS = [
  // Title fonts (can also be used for headings/page text)
  { label: "Alfa Slab One", value: "'Alfa Slab One', serif" },
  { label: "Anton", value: "Anton, sans-serif" },
  { label: "Belanosima", value: "Belanosima, sans-serif" },
  { label: "BioRhyme", value: "'BioRhyme', serif" },
  { label: "Chango", value: "Chango, cursive" },
  { label: "Domine", value: "Domine, serif" },
  { label: "Fustat", value: "Fustat, sans-serif" },
  { label: "Gasoek One", value: "'Gasoek One', cursive" },
  { label: "IBM Plex Sans", value: "'IBM Plex Sans', sans-serif" },
  { label: "Kavivanar", value: "Kavivanar, cursive" },
  { label: "Manrope", value: "Manrope, sans-serif" },
  { label: "Old Standard TT", value: "'Old Standard TT', serif" },
  { label: "Oxanium", value: "Oxanium, cursive" },
  { label: "Playfair Display", value: "'Playfair Display', serif" },
  { label: "Poppins", value: "Poppins, sans-serif" },
  { label: "Roboto", value: "Roboto, sans-serif" },
  { label: "Roboto Slab", value: "'Roboto Slab', serif" },
  { label: "Space Mono", value: "'Space Mono', monospace" },
  { label: "Viga", value: "Viga, sans-serif" },
  { label: "Bebas Neue", value: "'Bebas Neue', cursive" },
  { label: "Oswald", value: "Oswald, sans-serif" },
  { label: "Cinzel", value: "Cinzel, serif" },

  // Page fonts (content text)
  { label: "Albert Sans", value: "'Albert Sans', sans-serif" },
  { label: "Bricolage Grotesque", value: "'Bricolage Grotesque', sans-serif" },
  { label: "DM Sans", value: "'DM Sans', sans-serif" },
  { label: "Epilogue", value: "Epilogue, sans-serif" },
  { label: "Inter", value: "Inter, sans-serif" },
  { label: "Lato", value: "Lato, sans-serif" },
  { label: "Patrick Hand", value: "'Patrick Hand', cursive" },
  { label: "Red Hat Display", value: "'Red Hat Display', sans-serif" },
  { label: "Space Grotesk", value: "'Space Grotesk', sans-serif" },
  { label: "Castoro Titling", value: "'Castoro Titling', serif" },
  { label: "Bitter", value: "Bitter, serif" },
  { label: "Crushed", value: "Crushed, cursive" },
  { label: "Duru Sans", value: "'Duru Sans', sans-serif" },
  { label: "Gloock", value: "Gloock, serif" },
  { label: "IBM Plex Mono", value: "'IBM Plex Mono', monospace" },
  { label: "IBM Plex Serif", value: "'IBM Plex Serif', serif" },
  { label: "Lora", value: "Lora, serif" },
  { label: "Merriweather", value: "Merriweather, serif" },
  { label: "Roboto Serif", value: "'Roboto Serif', serif" },
  { label: "Source Serif Pro", value: "'Source Serif Pro', serif" },
];

export const COUNTRY_LIST = [
  { code: "AF", name: "Afghanistan" },
  { code: "AX", name: "Åland Islands" },
  { code: "AL", name: "Albania" },
  { code: "DZ", name: "Algeria" },
  { code: "AS", name: "American Samoa" },
  { code: "AD", name: "Andorra" },
  { code: "AO", name: "Angola" },
  { code: "AI", name: "Anguilla" },
  { code: "AQ", name: "Antarctica" },
  { code: "AG", name: "Antigua and Barbuda" },
  { code: "AR", name: "Argentina" },
  { code: "AM", name: "Armenia" },
  { code: "AW", name: "Aruba" },
  { code: "AU", name: "Australia" },
  { code: "AT", name: "Austria" },
  { code: "AZ", name: "Azerbaijan" },
  { code: "BS", name: "Bahamas" },
  { code: "BH", name: "Bahrain" },
  { code: "BD", name: "Bangladesh" },
  { code: "BB", name: "Barbados" },
  { code: "BY", name: "Belarus" },
  { code: "BE", name: "Belgium" },
  { code: "BZ", name: "Belize" },
  { code: "BJ", name: "Benin" },
  { code: "BM", name: "Bermuda" },
  { code: "BT", name: "Bhutan" },
  { code: "BO", name: "Bolivia (Plurinational State of)" },
  { code: "BA", name: "Bosnia and Herzegovina" },
  { code: "BW", name: "Botswana" },
  { code: "BV", name: "Bouvet Island" },
  { code: "BR", name: "Brazil" },
  { code: "IO", name: "British Indian Ocean Territory" },
  { code: "BN", name: "Brunei Darussalam" },
  { code: "BG", name: "Bulgaria" },
  { code: "BF", name: "Burkina Faso" },
  { code: "BI", name: "Burundi" },
  { code: "CV", name: "Cabo Verde" },
  { code: "KH", name: "Cambodia" },
  { code: "CM", name: "Cameroon" },
  { code: "CA", name: "Canada" },
  { code: "BQ", name: "Caribbean Netherlands" },
  { code: "KY", name: "Cayman Islands" },
  { code: "CF", name: "Central African Republic" },
  { code: "TD", name: "Chad" },
  { code: "CL", name: "Chile" },
  { code: "CN", name: "China" },
  { code: "CX", name: "Christmas Island" },
  { code: "CC", name: "Cocos (Keeling) Islands" },
  { code: "CO", name: "Colombia" },
  { code: "KM", name: "Comoros" },
  { code: "CG", name: "Congo" },
  { code: "CD", name: "Congo, Democratic Republic of the" },
  { code: "CK", name: "Cook Islands" },
  { code: "CR", name: "Costa Rica" },
  { code: "HR", name: "Croatia" },
  { code: "CU", name: "Cuba" },
  { code: "CW", name: "Curaçao" },
  { code: "CY", name: "Cyprus" },
  { code: "CZ", name: "Czech Republic" },
  { code: "CI", name: "Côte d'Ivoire" },
  { code: "DK", name: "Denmark" },
  { code: "DJ", name: "Djibouti" },
  { code: "DM", name: "Dominica" },
  { code: "DO", name: "Dominican Republic" },
  { code: "EC", name: "Ecuador" },
  { code: "EG", name: "Egypt" },
  { code: "SV", name: "El Salvador" },
  { code: "GQ", name: "Equatorial Guinea" },
  { code: "ER", name: "Eritrea" },
  { code: "EE", name: "Estonia" },
  { code: "SZ", name: "Eswatini (Swaziland)" },
  { code: "ET", name: "Ethiopia" },
  { code: "FK", name: "Falkland Islands (Malvinas)" },
  { code: "FO", name: "Faroe Islands" },
  { code: "FJ", name: "Fiji" },
  { code: "FI", name: "Finland" },
  { code: "FR", name: "France" },
  { code: "GF", name: "French Guiana" },
  { code: "PF", name: "French Polynesia" },
  { code: "TF", name: "French Southern Territories" },
  { code: "GA", name: "Gabon" },
  { code: "GM", name: "Gambia" },
  { code: "GE", name: "Georgia" },
  { code: "DE", name: "Germany" },
  { code: "GH", name: "Ghana" },
  { code: "GI", name: "Gibraltar" },
  { code: "GR", name: "Greece" },
  { code: "GL", name: "Greenland" },
  { code: "GD", name: "Grenada" },
  { code: "GP", name: "Guadeloupe" },
  { code: "GU", name: "Guam" },
  { code: "GT", name: "Guatemala" },
  { code: "GG", name: "Guernsey" },
  { code: "GN", name: "Guinea" },
  { code: "GW", name: "Guinea-Bissau" },
  { code: "GY", name: "Guyana" },
  { code: "HT", name: "Haiti" },
  { code: "HM", name: "Heard Island and Mcdonald Islands" },
  { code: "HN", name: "Honduras" },
  { code: "HK", name: "Hong Kong" },
  { code: "HU", name: "Hungary" },
  { code: "IS", name: "Iceland" },
  { code: "IN", name: "India" },
  { code: "ID", name: "Indonesia" },
  { code: "IR", name: "Iran" },
  { code: "IQ", name: "Iraq" },
  { code: "IE", name: "Ireland" },
  { code: "IM", name: "Isle of Man" },
  { code: "IL", name: "Israel" },
  { code: "IT", name: "Italy" },
  { code: "JM", name: "Jamaica" },
  { code: "JP", name: "Japan" },
  { code: "JE", name: "Jersey" },
  { code: "JO", name: "Jordan" },
  { code: "KZ", name: "Kazakhstan" },
  { code: "KE", name: "Kenya" },
  { code: "KI", name: "Kiribati" },
  { code: "KP", name: "Korea, North" },
  { code: "KR", name: "Korea, South" },
  { code: "XK", name: "Kosovo" },
  { code: "KW", name: "Kuwait" },
  { code: "KG", name: "Kyrgyzstan" },
  { code: "LA", name: "Lao People's Democratic Republic" },
  { code: "LV", name: "Latvia" },
  { code: "LB", name: "Lebanon" },
  { code: "LS", name: "Lesotho" },
  { code: "LR", name: "Liberia" },
  { code: "LY", name: "Libya" },
  { code: "LI", name: "Liechtenstein" },
  { code: "LT", name: "Lithuania" },
  { code: "LU", name: "Luxembourg" },
  { code: "MO", name: "Macao" },
  { code: "MK", name: "Macedonia North" },
  { code: "MG", name: "Madagascar" },
  { code: "MW", name: "Malawi" },
  { code: "MY", name: "Malaysia" },
  { code: "MV", name: "Maldives" },
  { code: "ML", name: "Mali" },
  { code: "MT", name: "Malta" },
  { code: "MH", name: "Marshall Islands" },
  { code: "MQ", name: "Martinique" },
  { code: "MR", name: "Mauritania" },
  { code: "MU", name: "Mauritius" },
  { code: "YT", name: "Mayotte" },
  { code: "MX", name: "Mexico" },
  { code: "FM", name: "Micronesia" },
  { code: "MD", name: "Moldova" },
  { code: "MC", name: "Monaco" },
  { code: "MN", name: "Mongolia" },
  { code: "ME", name: "Montenegro" },
  { code: "MS", name: "Montserrat" },
  { code: "MA", name: "Morocco" },
  { code: "MZ", name: "Mozambique" },
  { code: "MM", name: "Myanmar (Burma)" },
  { code: "NA", name: "Namibia" },
  { code: "NR", name: "Nauru" },
  { code: "NP", name: "Nepal" },
  { code: "NL", name: "Netherlands" },
  { code: "AN", name: "Netherlands Antilles" },
  { code: "NC", name: "New Caledonia" },
  { code: "NZ", name: "New Zealand" },
  { code: "NI", name: "Nicaragua" },
  { code: "NE", name: "Niger" },
  { code: "NG", name: "Nigeria" },
  { code: "NU", name: "Niue" },
  { code: "NF", name: "Norfolk Island" },
  { code: "MP", name: "Northern Mariana Islands" },
  { code: "NO", name: "Norway" },
  { code: "OM", name: "Oman" },
  { code: "PK", name: "Pakistan" },
  { code: "PW", name: "Palau" },
  { code: "PS", name: "Palestine" },
  { code: "PA", name: "Panama" },
  { code: "PG", name: "Papua New Guinea" },
  { code: "PY", name: "Paraguay" },
  { code: "PE", name: "Peru" },
  { code: "PH", name: "Philippines" },
  { code: "PN", name: "Pitcairn Islands" },
  { code: "PL", name: "Poland" },
  { code: "PT", name: "Portugal" },
  { code: "PR", name: "Puerto Rico" },
  { code: "QA", name: "Qatar" },
  { code: "RE", name: "Reunion" },
  { code: "RO", name: "Romania" },
  { code: "RU", name: "Russian Federation" },
  { code: "RW", name: "Rwanda" },
  { code: "BL", name: "Saint Barthelemy" },
  { code: "SH", name: "Saint Helena" },
  { code: "KN", name: "Saint Kitts and Nevis" },
  { code: "LC", name: "Saint Lucia" },
  { code: "MF", name: "Saint Martin" },
  { code: "PM", name: "Saint Pierre and Miquelon" },
  { code: "VC", name: "Saint Vincent and the Grenadines" },
  { code: "WS", name: "Samoa" },
  { code: "SM", name: "San Marino" },
  { code: "ST", name: "Sao Tome and Principe" },
  { code: "SA", name: "Saudi Arabia" },
  { code: "SN", name: "Senegal" },
  { code: "RS", name: "Serbia" },
  { code: "CS", name: "Serbia and Montenegro" },
  { code: "SC", name: "Seychelles" },
  { code: "SL", name: "Sierra Leone" },
  { code: "SG", name: "Singapore" },
  { code: "SX", name: "Sint Maarten" },
  { code: "SK", name: "Slovakia" },
  { code: "SI", name: "Slovenia" },
  { code: "SB", name: "Solomon Islands" },
  { code: "SO", name: "Somalia" },
  { code: "ZA", name: "South Africa" },
  { code: "GS", name: "South Georgia and the South Sandwich Islands" },
  { code: "SS", name: "South Sudan" },
  { code: "ES", name: "Spain" },
  { code: "LK", name: "Sri Lanka" },
  { code: "SD", name: "Sudan" },
  { code: "SR", name: "Suriname" },
  { code: "SJ", name: "Svalbard and Jan Mayen" },
  { code: "SE", name: "Sweden" },
  { code: "CH", name: "Switzerland" },
  { code: "SY", name: "Syria" },
  { code: "TW", name: "Taiwan" },
  { code: "TJ", name: "Tajikistan" },
  { code: "TZ", name: "Tanzania" },
  { code: "TH", name: "Thailand" },
  { code: "TL", name: "Timor-Leste" },
  { code: "TG", name: "Togo" },
  { code: "TK", name: "Tokelau" },
  { code: "TO", name: "Tonga" },
  { code: "TT", name: "Trinidad and Tobago" },
  { code: "TN", name: "Tunisia" },
  { code: "TR", name: "Turkey (Türkiye)" },
  { code: "TM", name: "Turkmenistan" },
  { code: "TC", name: "Turks and Caicos Islands" },
  { code: "TV", name: "Tuvalu" },
  { code: "UM", name: "U.S. Outlying Islands" },
  { code: "UG", name: "Uganda" },
  { code: "UA", name: "Ukraine" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "GB", name: "United Kingdom" },
  { code: "US", name: "United States" },
  { code: "UY", name: "Uruguay" },
  { code: "UZ", name: "Uzbekistan" },
  { code: "VU", name: "Vanuatu" },
  { code: "VA", name: "Vatican City Holy See" },
  { code: "VE", name: "Venezuela" },
  { code: "VN", name: "Vietnam" },
  { code: "VG", name: "Virgin Islands, British" },
  { code: "VI", name: "Virgin Islands, U.S" },
  { code: "WF", name: "Wallis and Futuna" },
  { code: "EH", name: "Western Sahara" },
  { code: "YE", name: "Yemen" },
  { code: "ZM", name: "Zambia" },
  { code: "ZW", name: "Zimbabwe" },
];
